import { render, staticRenderFns } from "./Aliance.vue?vue&type=template&id=1e81f694&scoped=true&"
import script from "./Aliance.vue?vue&type=script&lang=js&"
export * from "./Aliance.vue?vue&type=script&lang=js&"
import style0 from "./Aliance.vue?vue&type=style&index=0&id=1e81f694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e81f694",
  null
  
)

export default component.exports